// src/application/hooks/useAddCompany.js
import { useState } from 'react';
import { ApiUserRepository } from '../../infrastructure/repositories/ApiUserRepository';
import { AddUser } from '../UseCase/AddUser';
import userApiClient from '../../infrastructure/userApiClient';
import useApiClient from '../../infrastructure/apiClient';
import { UpdateUser } from '../UseCase/UpdateUser';


export const useUpdateUser = () => {
  const [updateduser, setUpdatedUser] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const apiClient = useApiClient();

  const updateUser = async (user) => {
    debugger;
    const userRepository = new ApiUserRepository(userApiClient,apiClient);
    const updateUserUseCase = new UpdateUser(userRepository);

    try {
      debugger;
      setLoading(true);      
      console.log(loading);
      console.log('I am in usecompany hook');
      const result = await updateUserUseCase.execute(user);
      setUpdatedUser(result);
    } catch (err) {
      setError(err.message);
    }
    finally{
      debugger;
      setLoading(false);
      console.log(loading);
    }
  };

  return { updateduser, updateUser, error, loading };
};
export default useUpdateUser;
